module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHorizontal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(_vm._s(_vm.text) + "\n      ")])])])]) : _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isDisabled
    }
  }), _vm._v(_vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-192076a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VACheckBox.vue
// module id = 699
// module chunks = 1